import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { lazadaProductStatusUpdate } from '../../services/Api';

// Async thunk for updating product status
export const updateProductStatus = createAsyncThunk(
    'productStatus/updateStatus',
    async (updateData, { rejectWithValue }) => {
        try {
            const response = await lazadaProductStatusUpdate(updateData);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const productStatusSlice = createSlice({
    name: 'productStatus',
    initialState: {
        loading: {},
        error: null,
        success: false,
        updateData: null
    },
    reducers: {
        clearStatusState: (state) => {
            state.loading = {};
            state.error = null;
            state.success = false;
            state.updateData = null;
        },
        clearError: (state) => {
            state.error = null;
        },
        setLoading: (state, action) => {
            const { id, isLoading } = action.payload;
            if (isLoading) {
                state.loading[id] = true;
            } else {
                delete state.loading[id];
            }
        }
    },
    extraReducers: (builder) => {
        builder
            // Update product status
            .addCase(updateProductStatus.pending, (state, action) => {
                const { id, skuId } = action.meta.arg;
                const loadingId = skuId ? `${id}_${skuId}` : id.toString();
                state.loading[loadingId] = true;
                state.error = null;
                state.success = false;
            })
            .addCase(updateProductStatus.fulfilled, (state, action) => {
                const { id, skuId } = action.meta.arg;
                const loadingId = skuId ? `${id}_${skuId}` : id.toString();
                delete state.loading[loadingId];
                state.success = true;
                state.updateData = action.payload;
                state.error = null;
            })
            .addCase(updateProductStatus.rejected, (state, action) => {
                const { id, skuId } = action.meta.arg;
                const loadingId = skuId ? `${id}_${skuId}` : id.toString();
                delete state.loading[loadingId];
                state.success = false;
                state.error = action.payload;
            });
    }
});

export const { clearStatusState, clearError, setLoading } = productStatusSlice.actions;
export default productStatusSlice.reducer;